// Phase 5.3 — Interface Language selector (native names). Distinct from "I speak" /
// "I'm learning". Changing it updates the UI immediately and persists at account level;
// it never touches the active Learning Profile.
import { Globe } from "lucide-react";
import { useI18n } from "@/context/I18nContext";
import { UI_LOCALES } from "@/lib/i18n";

export default function InterfaceLanguageSelect({ compact = false }) {
  const { locale, setLocale } = useI18n();
  return (
    <div className={compact ? "" : "flex items-center gap-2"}>
      {!compact && <Globe className="w-4 h-4 text-gray-500 shrink-0" />}
      <select
        className="nb-input w-full"
        value={locale}
        onChange={(e) => setLocale(e.target.value)}
        data-testid="interface-language-select"
        aria-label="Interface language"
      >
        {UI_LOCALES.map((l) => (
          <option key={l.code} value={l.code}>{l.native}</option>
        ))}
      </select>
    </div>
  );
}
